import { AnimatePresence, motion } from "framer-motion";
import { FaClock } from "react-icons/fa";
import logotipo from "../img/Logotipo.webp";
import { HORARIOS_TEXTO } from "./Utils/horariosSucursal";

const ModalCerrado = ({ mostrar, onContinuar }) => {
  const sucursales = [HORARIOS_TEXTO.caraballeda, HORARIOS_TEXTO.maiquetia];

  return (
    <AnimatePresence>
      {mostrar && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-white/60 backdrop-blur-md"
            aria-hidden="true"
          />

          <motion.div
            initial={{ opacity: 0, y: 32, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.96 }}
            transition={{ type: "spring", stiffness: 320, damping: 28 }}
            className="relative w-full max-w-[400px] overflow-hidden rounded-3xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.12)] ring-1 ring-neutral-200/80"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-cerrado-titulo"
          >
            <div className="absolute -top-20 -right-20 h-44 w-44 rounded-full bg-red-100/80 blur-3xl" />
            <div className="absolute -bottom-16 -left-16 h-36 w-36 rounded-full bg-yellow-100/80 blur-3xl" />

            <div className="relative p-6 sm:p-8">
              <div className="mb-6 flex justify-center">
                <img
                  src={logotipo}
                  alt="Logo"
                  className="h-24 w-24 rounded-full object-cover shadow-md ring-2 ring-neutral-100"
                />
              </div>

              <div className="text-center">
                <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-red-500">
                  Fuera de horario
                </p>
                <h2
                  id="modal-cerrado-titulo"
                  className="mb-4 flex items-center justify-center gap-2.5 text-2xl font-bold leading-tight text-neutral-800 sm:text-[1.65rem]"
                >
                  <FaClock className="text-yellow-500 shrink-0" aria-hidden="true" />
                  Estamos cerrados
                </h2>

                <div className="mb-4 space-y-3 text-left">
                  {sucursales.map((sucursal) => (
                    <div
                      key={sucursal.nombre}
                      className="rounded-2xl bg-neutral-50 px-3.5 py-3 ring-1 ring-neutral-100"
                    >
                      <p className="mb-1.5 text-xs font-bold uppercase tracking-wide text-neutral-700">
                        {sucursal.nombre}
                      </p>
                      {sucursal.lineas.map((linea) => (
                        <p
                          key={linea}
                          className="text-sm font-semibold leading-snug text-yellow-600"
                        >
                          {linea}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>

                <p className="text-sm leading-relaxed text-neutral-500">
                  Explora el menú y arma tu pedido para cuando abramos.
                </p>
              </div>

              <motion.button
                type="button"
                onClick={onContinuar}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="mt-7 w-full rounded-2xl bg-gradient-to-r from-yellow-400 to-yellow-500 py-3.5 text-sm font-bold text-neutral-900 shadow-[0_8px_24px_rgba(250,204,21,0.3)] transition-shadow hover:shadow-[0_12px_28px_rgba(250,204,21,0.4)]"
              >
                Ver menú
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalCerrado;
